import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, TrendingUp } from 'lucide-react';

const nfFa = new Intl.NumberFormat('fa-IR');

function SparkBars({ values = [3, 6, 4, 8, 5, 9], colorClass = 'bg-blue-500' }) {
  const max = Math.max(...values, 1);
  const seen = new Map();
  return (
    <div className="flex items-end gap-1 h-10">
      {values.map((v) => {
        const nextCount = (seen.get(v) || 0) + 1;
        seen.set(v, nextCount);
        return (
          <div
            key={`${v}-${nextCount}`}
            className={`w-2 rounded-sm ${colorClass} opacity-80`}
            style={{ height: `${Math.round((v / max) * 100)}%` }}
          />
        );
      })}
    </div>
  );
}

function StatCard({ label, value, unit, route, accent = 'blue', sparkValues }) {
  const navigate = useNavigate();

  const accentMap = {
    blue: {
      ring: 'ring-blue-100',
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      spark: 'bg-blue-600'
    },
    amber: {
      ring: 'ring-amber-100',
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      spark: 'bg-amber-600'
    },
    emerald: {
      ring: 'ring-emerald-100',
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      spark: 'bg-emerald-600'
    }
  };

  const a = accentMap[accent] || accentMap.blue;

  return (
    <button
      type="button"
      onClick={() => navigate(route)}
      className={`w-full text-right rounded-3xl p-6 border border-gray-100 bg-white shadow-sm hover:shadow-md transition flex items-center justify-between gap-6 ring-1 ${a.ring}`}
    >
      <div className="min-w-0">
        <div className="flex items-center justify-between gap-3">
          <div className="text-[11px] text-gray-400 font-bold truncate">{label}</div>
          <div className={`flex items-center gap-1 text-[10px] font-extrabold ${a.text}`}>
            <TrendingUp size={12} />
            <span>نمایش</span>
            <ArrowLeft size={12} />
          </div>
        </div>

        <div className="mt-3 flex items-end gap-2">
          <div className={`w-10 h-10 rounded-2xl ${a.bg} border border-gray-100 flex items-center justify-center ${a.text} font-black`}>
            {nfFa.format(value)}
          </div>
          <div className="pb-1">
            <div className="text-lg font-black text-gray-800 leading-none">{nfFa.format(value)}</div>
            <div className="text-[10px] text-gray-400 font-bold mt-1">{unit}</div>
          </div>
        </div>
      </div>

      <div className="flex-shrink-0">
        <SparkBars values={sparkValues} colorClass={a.spark} />
      </div>
    </button>
  );
}

export default function TopStatsNav({ items }) {
  const safeItems = Array.isArray(items) ? items.slice(0, 2) : [];
  if (safeItems.length !== 2) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <StatCard {...safeItems[0]} />
      <StatCard {...safeItems[1]} />
    </div>
  );
}

